import React, { useContext } from 'react';
import Box from '../../../elements/Box';
import ImageHeader from './ImageHeader';
import Text from '../../../elements/Text';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';

const SectionHeadItem = (props) => {
  const { direction, theme } = useContext(Context);
  const {
    title,
    imageSettings,
    imageNotSelectedSettings,
    titleSettings,
    containerSettings,
    isSelected,
    selectedTabBarSettings,
    isMobile = false,
    isTabletViewPort = false,
    images_path,
    isShowPanels
  } = props;
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <Box style={style} className={className} {...containerSettings}>
      <ImageHeader
        focusable={false}
        selectedImageEffect={isSelected}
        image={images_path && images_path.length !== 0 ? images_path[0] : ''}
        imageNotSelectedSettings={
          isShowPanels && !isSelected && imageNotSelectedSettings !== undefined
            ? imageNotSelectedSettings
            : {}
        }
        {...imageSettings}
      />
      <Text {...titleSettings}>{title}</Text>
      {isSelected && (!isMobile || (isMobile && isTabletViewPort)) && (
        <Box {...selectedTabBarSettings}></Box>
      )}
    </Box>
  );
};

export default SectionHeadItem;
